import { render, staticRenderFns } from "./JobsManage.vue?vue&type=template&id=1b134aa2&scoped=true&"
import script from "./JobsManage.vue?vue&type=script&lang=js&"
export * from "./JobsManage.vue?vue&type=script&lang=js&"
import style0 from "./JobsManage.vue?vue&type=style&index=0&id=1b134aa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b134aa2",
  null
  
)

export default component.exports